// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               v5.28.3
// source: projectioneditor.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { Guid } from "./protobuf-net/bcl";

export const protobufPackage = "Cratis.Chronicle.Contracts.ProjectionEditor";

export enum ValidationResultSeverity {
  Unknown = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
  UNRECOGNIZED = -1,
}

export function validationResultSeverityFromJSON(object: any): ValidationResultSeverity {
  switch (object) {
    case 0:
    case "Unknown":
      return ValidationResultSeverity.Unknown;
    case 1:
    case "Information":
      return ValidationResultSeverity.Information;
    case 2:
    case "Warning":
      return ValidationResultSeverity.Warning;
    case 3:
    case "Error":
      return ValidationResultSeverity.Error;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ValidationResultSeverity.UNRECOGNIZED;
  }
}

export function validationResultSeverityToJSON(object: ValidationResultSeverity): string {
  switch (object) {
    case ValidationResultSeverity.Unknown:
      return "Unknown";
    case ValidationResultSeverity.Information:
      return "Information";
    case ValidationResultSeverity.Warning:
      return "Warning";
    case ValidationResultSeverity.Error:
      return "Error";
    case ValidationResultSeverity.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CommandResultGenerateDeclarativeCodeResponse {
  /** default value could not be applied: 00000000-0000-0000-0000-000000000000 */
  CorrelationId: Guid | undefined;
  IsAuthorized: boolean;
  ValidationResults: ValidationResult[];
  ExceptionMessages: string[];
  ExceptionStackTrace: string;
  AuthorizationFailureReason: string;
  Response: GenerateDeclarativeCodeResponse | undefined;
}

export interface DraftReadModel {
  Identifier: string;
  DisplayName: string;
  ContainerName: string;
  Schema: string;
}

export interface GenerateDeclarativeCodeRequest {
  EventStore: string;
  Namespace: string;
  Declaration: string;
  DraftReadModel: DraftReadModel | undefined;
  Language: string;
}

export interface GenerateDeclarativeCodeResponse {
  Code: string;
  Errors: ProjectionDeclarationSyntaxError[];
}

export interface GenerateModelBoundCodeRequest {
  EventStore: string;
  Namespace: string;
  Declaration: string;
  DraftReadModel: DraftReadModel | undefined;
  Language: string;
}

export interface ProjectionDeclarationSyntaxError {
  Message: string;
  Line: number;
  Column: number;
}

export interface ValidationResult {
  /** default value could not be applied: Error */
  Severity: ValidationResultSeverity;
  Message: string;
  Members: string[];
}

function createBaseCommandResultGenerateDeclarativeCodeResponse(): CommandResultGenerateDeclarativeCodeResponse {
  return {
    CorrelationId: undefined,
    IsAuthorized: false,
    ValidationResults: [],
    ExceptionMessages: [],
    ExceptionStackTrace: "",
    AuthorizationFailureReason: "",
    Response: undefined,
  };
}

export const CommandResultGenerateDeclarativeCodeResponse: MessageFns<CommandResultGenerateDeclarativeCodeResponse> = {
  encode(
    message: CommandResultGenerateDeclarativeCodeResponse,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.CorrelationId !== undefined) {
      Guid.encode(message.CorrelationId, writer.uint32(10).fork()).join();
    }
    if (message.IsAuthorized !== false) {
      writer.uint32(16).bool(message.IsAuthorized);
    }
    for (const v of message.ValidationResults) {
      ValidationResult.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.ExceptionMessages) {
      writer.uint32(34).string(v!);
    }
    if (message.ExceptionStackTrace !== "") {
      writer.uint32(42).string(message.ExceptionStackTrace);
    }
    if (message.AuthorizationFailureReason !== "") {
      writer.uint32(50).string(message.AuthorizationFailureReason);
    }
    if (message.Response !== undefined) {
      GenerateDeclarativeCodeResponse.encode(message.Response, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandResultGenerateDeclarativeCodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseCommandResultGenerateDeclarativeCodeResponse();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.CorrelationId = Guid.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.IsAuthorized = reader.bool();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.ValidationResults.push(ValidationResult.decode(reader, reader.uint32()));
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.ExceptionMessages.push(reader.string());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.ExceptionStackTrace = reader.string();
            continue;
          }
          case 6: {
            if (tag !== 50) {
              break;
            }

            message.AuthorizationFailureReason = reader.string();
            continue;
          }
          case 7: {
            if (tag !== 58) {
              break;
            }

            message.Response = GenerateDeclarativeCodeResponse.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): CommandResultGenerateDeclarativeCodeResponse {
    return {
      CorrelationId: isSet(object.CorrelationId) ? Guid.fromJSON(object.CorrelationId) : undefined,
      IsAuthorized: isSet(object.IsAuthorized) ? globalThis.Boolean(object.IsAuthorized) : false,
      ValidationResults: globalThis.Array.isArray(object?.ValidationResults)
        ? object.ValidationResults.map((e: any) => ValidationResult.fromJSON(e))
        : [],
      ExceptionMessages: globalThis.Array.isArray(object?.ExceptionMessages)
        ? object.ExceptionMessages.map((e: any) => globalThis.String(e))
        : [],
      ExceptionStackTrace: isSet(object.ExceptionStackTrace) ? globalThis.String(object.ExceptionStackTrace) : "",
      AuthorizationFailureReason: isSet(object.AuthorizationFailureReason)
        ? globalThis.String(object.AuthorizationFailureReason)
        : "",
      Response: isSet(object.Response) ? GenerateDeclarativeCodeResponse.fromJSON(object.Response) : undefined,
    };
  },

  toJSON(message: CommandResultGenerateDeclarativeCodeResponse): unknown {
    const obj: any = {};
    if (message.CorrelationId !== undefined) {
      obj.CorrelationId = Guid.toJSON(message.CorrelationId);
    }
    if (message.IsAuthorized !== false) {
      obj.IsAuthorized = message.IsAuthorized;
    }
    if (message.ValidationResults?.length) {
      obj.ValidationResults = message.ValidationResults.map((e) => ValidationResult.toJSON(e));
    }
    if (message.ExceptionMessages?.length) {
      obj.ExceptionMessages = message.ExceptionMessages;
    }
    if (message.ExceptionStackTrace !== "") {
      obj.ExceptionStackTrace = message.ExceptionStackTrace;
    }
    if (message.AuthorizationFailureReason !== "") {
      obj.AuthorizationFailureReason = message.AuthorizationFailureReason;
    }
    if (message.Response !== undefined) {
      obj.Response = GenerateDeclarativeCodeResponse.toJSON(message.Response);
    }
    return obj;
  },

  create(
    base?: DeepPartial<CommandResultGenerateDeclarativeCodeResponse>,
  ): CommandResultGenerateDeclarativeCodeResponse {
    return CommandResultGenerateDeclarativeCodeResponse.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<CommandResultGenerateDeclarativeCodeResponse>,
  ): CommandResultGenerateDeclarativeCodeResponse {
    const message = createBaseCommandResultGenerateDeclarativeCodeResponse();
    message.CorrelationId = (object.CorrelationId !== undefined && object.CorrelationId !== null)
      ? Guid.fromPartial(object.CorrelationId)
      : undefined;
    message.IsAuthorized = object.IsAuthorized ?? false;
    message.ValidationResults = object.ValidationResults?.map((e) => ValidationResult.fromPartial(e)) || [];
    message.ExceptionMessages = object.ExceptionMessages?.map((e) => e) || [];
    message.ExceptionStackTrace = object.ExceptionStackTrace ?? "";
    message.AuthorizationFailureReason = object.AuthorizationFailureReason ?? "";
    message.Response = (object.Response !== undefined && object.Response !== null)
      ? GenerateDeclarativeCodeResponse.fromPartial(object.Response)
      : undefined;
    return message;
  },
};

function createBaseDraftReadModel(): DraftReadModel {
  return { Identifier: "", DisplayName: "", ContainerName: "", Schema: "" };
}

export const DraftReadModel: MessageFns<DraftReadModel> = {
  encode(message: DraftReadModel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Identifier !== "") {
      writer.uint32(10).string(message.Identifier);
    }
    if (message.DisplayName !== "") {
      writer.uint32(18).string(message.DisplayName);
    }
    if (message.ContainerName !== "") {
      writer.uint32(26).string(message.ContainerName);
    }
    if (message.Schema !== "") {
      writer.uint32(34).string(message.Schema);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DraftReadModel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseDraftReadModel();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.Identifier = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.DisplayName = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.ContainerName = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.Schema = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): DraftReadModel {
    return {
      Identifier: isSet(object.Identifier) ? globalThis.String(object.Identifier) : "",
      DisplayName: isSet(object.DisplayName) ? globalThis.String(object.DisplayName) : "",
      ContainerName: isSet(object.ContainerName) ? globalThis.String(object.ContainerName) : "",
      Schema: isSet(object.Schema) ? globalThis.String(object.Schema) : "",
    };
  },

  toJSON(message: DraftReadModel): unknown {
    const obj: any = {};
    if (message.Identifier !== "") {
      obj.Identifier = message.Identifier;
    }
    if (message.DisplayName !== "") {
      obj.DisplayName = message.DisplayName;
    }
    if (message.ContainerName !== "") {
      obj.ContainerName = message.ContainerName;
    }
    if (message.Schema !== "") {
      obj.Schema = message.Schema;
    }
    return obj;
  },

  create(base?: DeepPartial<DraftReadModel>): DraftReadModel {
    return DraftReadModel.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DraftReadModel>): DraftReadModel {
    const message = createBaseDraftReadModel();
    message.Identifier = object.Identifier ?? "";
    message.DisplayName = object.DisplayName ?? "";
    message.ContainerName = object.ContainerName ?? "";
    message.Schema = object.Schema ?? "";
    return message;
  },
};

function createBaseGenerateDeclarativeCodeRequest(): GenerateDeclarativeCodeRequest {
  return { EventStore: "", Namespace: "", Declaration: "", DraftReadModel: undefined, Language: "" };
}

export const GenerateDeclarativeCodeRequest: MessageFns<GenerateDeclarativeCodeRequest> = {
  encode(message: GenerateDeclarativeCodeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.EventStore !== "") {
      writer.uint32(10).string(message.EventStore);
    }
    if (message.Namespace !== "") {
      writer.uint32(18).string(message.Namespace);
    }
    if (message.Declaration !== "") {
      writer.uint32(26).string(message.Declaration);
    }
    if (message.DraftReadModel !== undefined) {
      DraftReadModel.encode(message.DraftReadModel, writer.uint32(34).fork()).join();
    }
    if (message.Language !== "") {
      writer.uint32(42).string(message.Language);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateDeclarativeCodeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseGenerateDeclarativeCodeRequest();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.EventStore = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.Namespace = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.Declaration = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.DraftReadModel = DraftReadModel.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.Language = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): GenerateDeclarativeCodeRequest {
    return {
      EventStore: isSet(object.EventStore) ? globalThis.String(object.EventStore) : "",
      Namespace: isSet(object.Namespace) ? globalThis.String(object.Namespace) : "",
      Declaration: isSet(object.Declaration) ? globalThis.String(object.Declaration) : "",
      DraftReadModel: isSet(object.DraftReadModel) ? DraftReadModel.fromJSON(object.DraftReadModel) : undefined,
      Language: isSet(object.Language) ? globalThis.String(object.Language) : "",
    };
  },

  toJSON(message: GenerateDeclarativeCodeRequest): unknown {
    const obj: any = {};
    if (message.EventStore !== "") {
      obj.EventStore = message.EventStore;
    }
    if (message.Namespace !== "") {
      obj.Namespace = message.Namespace;
    }
    if (message.Declaration !== "") {
      obj.Declaration = message.Declaration;
    }
    if (message.DraftReadModel !== undefined) {
      obj.DraftReadModel = DraftReadModel.toJSON(message.DraftReadModel);
    }
    if (message.Language !== "") {
      obj.Language = message.Language;
    }
    return obj;
  },

  create(base?: DeepPartial<GenerateDeclarativeCodeRequest>): GenerateDeclarativeCodeRequest {
    return GenerateDeclarativeCodeRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GenerateDeclarativeCodeRequest>): GenerateDeclarativeCodeRequest {
    const message = createBaseGenerateDeclarativeCodeRequest();
    message.EventStore = object.EventStore ?? "";
    message.Namespace = object.Namespace ?? "";
    message.Declaration = object.Declaration ?? "";
    message.DraftReadModel = (object.DraftReadModel !== undefined && object.DraftReadModel !== null)
      ? DraftReadModel.fromPartial(object.DraftReadModel)
      : undefined;
    message.Language = object.Language ?? "";
    return message;
  },
};

function createBaseGenerateDeclarativeCodeResponse(): GenerateDeclarativeCodeResponse {
  return { Code: "", Errors: [] };
}

export const GenerateDeclarativeCodeResponse: MessageFns<GenerateDeclarativeCodeResponse> = {
  encode(message: GenerateDeclarativeCodeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Code !== "") {
      writer.uint32(10).string(message.Code);
    }
    for (const v of message.Errors) {
      ProjectionDeclarationSyntaxError.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateDeclarativeCodeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseGenerateDeclarativeCodeResponse();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.Code = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.Errors.push(ProjectionDeclarationSyntaxError.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): GenerateDeclarativeCodeResponse {
    return {
      Code: isSet(object.Code) ? globalThis.String(object.Code) : "",
      Errors: globalThis.Array.isArray(object?.Errors)
        ? object.Errors.map((e: any) => ProjectionDeclarationSyntaxError.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GenerateDeclarativeCodeResponse): unknown {
    const obj: any = {};
    if (message.Code !== "") {
      obj.Code = message.Code;
    }
    if (message.Errors?.length) {
      obj.Errors = message.Errors.map((e) => ProjectionDeclarationSyntaxError.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GenerateDeclarativeCodeResponse>): GenerateDeclarativeCodeResponse {
    return GenerateDeclarativeCodeResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GenerateDeclarativeCodeResponse>): GenerateDeclarativeCodeResponse {
    const message = createBaseGenerateDeclarativeCodeResponse();
    message.Code = object.Code ?? "";
    message.Errors = object.Errors?.map((e) => ProjectionDeclarationSyntaxError.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGenerateModelBoundCodeRequest(): GenerateModelBoundCodeRequest {
  return { EventStore: "", Namespace: "", Declaration: "", DraftReadModel: undefined, Language: "" };
}

export const GenerateModelBoundCodeRequest: MessageFns<GenerateModelBoundCodeRequest> = {
  encode(message: GenerateModelBoundCodeRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.EventStore !== "") {
      writer.uint32(10).string(message.EventStore);
    }
    if (message.Namespace !== "") {
      writer.uint32(18).string(message.Namespace);
    }
    if (message.Declaration !== "") {
      writer.uint32(26).string(message.Declaration);
    }
    if (message.DraftReadModel !== undefined) {
      DraftReadModel.encode(message.DraftReadModel, writer.uint32(34).fork()).join();
    }
    if (message.Language !== "") {
      writer.uint32(42).string(message.Language);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateModelBoundCodeRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseGenerateModelBoundCodeRequest();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.EventStore = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.Namespace = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.Declaration = reader.string();
            continue;
          }
          case 4: {
            if (tag !== 34) {
              break;
            }

            message.DraftReadModel = DraftReadModel.decode(reader, reader.uint32());
            continue;
          }
          case 5: {
            if (tag !== 42) {
              break;
            }

            message.Language = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): GenerateModelBoundCodeRequest {
    return {
      EventStore: isSet(object.EventStore) ? globalThis.String(object.EventStore) : "",
      Namespace: isSet(object.Namespace) ? globalThis.String(object.Namespace) : "",
      Declaration: isSet(object.Declaration) ? globalThis.String(object.Declaration) : "",
      DraftReadModel: isSet(object.DraftReadModel) ? DraftReadModel.fromJSON(object.DraftReadModel) : undefined,
      Language: isSet(object.Language) ? globalThis.String(object.Language) : "",
    };
  },

  toJSON(message: GenerateModelBoundCodeRequest): unknown {
    const obj: any = {};
    if (message.EventStore !== "") {
      obj.EventStore = message.EventStore;
    }
    if (message.Namespace !== "") {
      obj.Namespace = message.Namespace;
    }
    if (message.Declaration !== "") {
      obj.Declaration = message.Declaration;
    }
    if (message.DraftReadModel !== undefined) {
      obj.DraftReadModel = DraftReadModel.toJSON(message.DraftReadModel);
    }
    if (message.Language !== "") {
      obj.Language = message.Language;
    }
    return obj;
  },

  create(base?: DeepPartial<GenerateModelBoundCodeRequest>): GenerateModelBoundCodeRequest {
    return GenerateModelBoundCodeRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GenerateModelBoundCodeRequest>): GenerateModelBoundCodeRequest {
    const message = createBaseGenerateModelBoundCodeRequest();
    message.EventStore = object.EventStore ?? "";
    message.Namespace = object.Namespace ?? "";
    message.Declaration = object.Declaration ?? "";
    message.DraftReadModel = (object.DraftReadModel !== undefined && object.DraftReadModel !== null)
      ? DraftReadModel.fromPartial(object.DraftReadModel)
      : undefined;
    message.Language = object.Language ?? "";
    return message;
  },
};

function createBaseProjectionDeclarationSyntaxError(): ProjectionDeclarationSyntaxError {
  return { Message: "", Line: 0, Column: 0 };
}

export const ProjectionDeclarationSyntaxError: MessageFns<ProjectionDeclarationSyntaxError> = {
  encode(message: ProjectionDeclarationSyntaxError, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Message !== "") {
      writer.uint32(10).string(message.Message);
    }
    if (message.Line !== 0) {
      writer.uint32(16).int32(message.Line);
    }
    if (message.Column !== 0) {
      writer.uint32(24).int32(message.Column);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectionDeclarationSyntaxError {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseProjectionDeclarationSyntaxError();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.Message = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.Line = reader.int32();
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.Column = reader.int32();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ProjectionDeclarationSyntaxError {
    return {
      Message: isSet(object.Message) ? globalThis.String(object.Message) : "",
      Line: isSet(object.Line) ? globalThis.Number(object.Line) : 0,
      Column: isSet(object.Column) ? globalThis.Number(object.Column) : 0,
    };
  },

  toJSON(message: ProjectionDeclarationSyntaxError): unknown {
    const obj: any = {};
    if (message.Message !== "") {
      obj.Message = message.Message;
    }
    if (message.Line !== 0) {
      obj.Line = Math.round(message.Line);
    }
    if (message.Column !== 0) {
      obj.Column = Math.round(message.Column);
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectionDeclarationSyntaxError>): ProjectionDeclarationSyntaxError {
    return ProjectionDeclarationSyntaxError.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectionDeclarationSyntaxError>): ProjectionDeclarationSyntaxError {
    const message = createBaseProjectionDeclarationSyntaxError();
    message.Message = object.Message ?? "";
    message.Line = object.Line ?? 0;
    message.Column = object.Column ?? 0;
    return message;
  },
};

function createBaseValidationResult(): ValidationResult {
  return { Severity: 0, Message: "", Members: [] };
}

export const ValidationResult: MessageFns<ValidationResult> = {
  encode(message: ValidationResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Severity !== 0) {
      writer.uint32(8).int32(message.Severity);
    }
    if (message.Message !== "") {
      writer.uint32(18).string(message.Message);
    }
    for (const v of message.Members) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ValidationResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseValidationResult();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.Severity = reader.int32() as any;
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.Message = reader.string();
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.Members.push(reader.string());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): ValidationResult {
    return {
      Severity: isSet(object.Severity) ? validationResultSeverityFromJSON(object.Severity) : 0,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : "",
      Members: globalThis.Array.isArray(object?.Members) ? object.Members.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ValidationResult): unknown {
    const obj: any = {};
    if (message.Severity !== 0) {
      obj.Severity = validationResultSeverityToJSON(message.Severity);
    }
    if (message.Message !== "") {
      obj.Message = message.Message;
    }
    if (message.Members?.length) {
      obj.Members = message.Members;
    }
    return obj;
  },

  create(base?: DeepPartial<ValidationResult>): ValidationResult {
    return ValidationResult.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ValidationResult>): ValidationResult {
    const message = createBaseValidationResult();
    message.Severity = object.Severity ?? 0;
    message.Message = object.Message ?? "";
    message.Members = object.Members?.map((e) => e) || [];
    return message;
  },
};

export type ProjectionEditorDefinition = typeof ProjectionEditorDefinition;
export const ProjectionEditorDefinition = {
  name: "ProjectionEditor",
  fullName: "Cratis.Chronicle.Contracts.ProjectionEditor.ProjectionEditor",
  methods: {
    generateDeclarativeCode: {
      name: "GenerateDeclarativeCode",
      requestType: GenerateDeclarativeCodeRequest as typeof GenerateDeclarativeCodeRequest,
      requestStream: false,
      responseType: CommandResultGenerateDeclarativeCodeResponse as typeof CommandResultGenerateDeclarativeCodeResponse,
      responseStream: false,
      options: {},
    },
    generateModelBoundCode: {
      name: "GenerateModelBoundCode",
      requestType: GenerateModelBoundCodeRequest as typeof GenerateModelBoundCodeRequest,
      requestStream: false,
      responseType: CommandResultGenerateDeclarativeCodeResponse as typeof CommandResultGenerateDeclarativeCodeResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface ProjectionEditorServiceImplementation<CallContextExt = {}> {
  generateDeclarativeCode(
    request: GenerateDeclarativeCodeRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CommandResultGenerateDeclarativeCodeResponse>>;
  generateModelBoundCode(
    request: GenerateModelBoundCodeRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CommandResultGenerateDeclarativeCodeResponse>>;
}

export interface ProjectionEditorClient<CallOptionsExt = {}> {
  generateDeclarativeCode(
    request: DeepPartial<GenerateDeclarativeCodeRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CommandResultGenerateDeclarativeCodeResponse>;
  generateModelBoundCode(
    request: DeepPartial<GenerateModelBoundCodeRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CommandResultGenerateDeclarativeCodeResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | bigint | undefined;

export type DeepPartial<T> = T extends bigint ? string | number | bigint
  : T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
